import { StyleSheet, View } from 'react-native';
import { Text, theme } from '@socrait/react';

import { VoiceNameEditor } from '~/components/VoiceNameEditor';
import { setupStore } from '~/store/setupStore';

import { setupStepStyles } from './setupStepStyles';

export const RosterStep = () => {
  const { voiceNameItems, setVoiceNameItems, setIsEditingVoiceName, addNameInputValue, setAddNameInputValue } =
    setupStore();

  const voiceNameCount = voiceNameItems.length;

  return (
    <View style={styles.container}>
      <Text style={setupStepStyles.headerText}>Add Your Roster</Text>
      <Text style={styles.subtitle}>
        {voiceNameCount} voice {voiceNameCount === 1 ? 'name' : 'names'} added
      </Text>
      <VoiceNameEditor
        addNameInputValue={addNameInputValue}
        onEditingStateChange={setIsEditingVoiceName}
        onVoiceNameItemsChange={setVoiceNameItems}
        setAddNameInputValue={setAddNameInputValue}
        showInstructionsByDefault={false}
        showLabel={false}
        voiceNameItems={voiceNameItems}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: theme.spacing.xlarge,
    minHeight: 0, // Critical: allows flex child to shrink
  },
  subtitle: {
    fontSize: theme.fontSizes.small,
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.small,
    textAlign: 'center',
  },
});
